import script from "./whGOnceImg8.vue?vue&type=script&setup=true&lang=js"
export * from "./whGOnceImg8.vue?vue&type=script&setup=true&lang=js"

import "./whGOnceImg8.vue?vue&type=style&index=0&id=312dacbb&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-312dacbb"]])

export default __exports__